__turbopack_context__.v({
  "blog": "work-additional-content-module-scss-module__kb3JEW__blog",
  "blogList": "work-additional-content-module-scss-module__kb3JEW__blogList",
  "blogMeta": "work-additional-content-module-scss-module__kb3JEW__blogMeta",
  "blogMetaBullet": "work-additional-content-module-scss-module__kb3JEW__blogMetaBullet",
  "blogPreview": "work-additional-content-module-scss-module__kb3JEW__blogPreview",
  "crossProduct": "work-additional-content-module-scss-module__kb3JEW__crossProduct",
  "crossProductGrid": "work-additional-content-module-scss-module__kb3JEW__crossProductGrid",
  "crossProductItem": "work-additional-content-module-scss-module__kb3JEW__crossProductItem",
  "crossProductItemTitle": "work-additional-content-module-scss-module__kb3JEW__crossProductItemTitle",
  "crossProductText": "work-additional-content-module-scss-module__kb3JEW__crossProductText",
  "readArticle": "work-additional-content-module-scss-module__kb3JEW__readArticle",
  "subjectTag": "work-additional-content-module-scss-module__kb3JEW__subjectTag",
  "subjects": "work-additional-content-module-scss-module__kb3JEW__subjects",
  "u-animation-bounce": "work-additional-content-module-scss-module__kb3JEW__u-animation-bounce",
});
